import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiSelect: { styleOverrides: ComponentsOverrides<Theme>['MuiSelect'] } = {
    styleOverrides: {
        icon: {
            color: 'inherit',
            right: 16,
        },
        select: {
            padding: '17px 16px',
            height: 22,
        },
        iconOutlined: ({ theme }) => ({
            right: theme.spacing(2),
        }),
    },
};
